export const BID_MIN_PROJECT_DURATION = 1
